module.exports = __webpack_public_path__ + "img/tag5.922bf3bb.png";